import { defaultTranslationLanguages } from '@repo/config/Global';

/**
 * Fallback catalogue of languages offered in the settings modal.
 */
export const translationLanguages = defaultTranslationLanguages;

/**
 * English is the "translation off" value throughout the feature — the modal
 * derives `translationActive` from it and the provider short-circuits on it.
 *
 * @param {string} [lang]
 * @returns {boolean}
 */
export function isEnglish(lang) {
    return !lang || lang.toLowerCase().split('-')[0] === 'en';
}
